import React from "react";
import { useForm } from "@mantine/form";
import { Alert, TextInput } from "@mantine/core";
import AuthWindow from "@components/Auth/AuthWindow";
import getFormElementError from "@lib/utils/form/getFormElementError";
import { showNotification } from "@mantine/notifications";
import { useRequestPasswordResetMutation } from "@lib/store/slices/password";
import { trackEvent } from "@components/Various/Analytics/gtag";
import BaseAuthForm from "@components/Auth/BaseAuthForm";

function ForgotPassword() {
  const form = useForm({
    initialValues: {
      email: "",
    },

    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });

  const [requestPasswordReset, { isLoading, error }] =
    useRequestPasswordResetMutation();
  const [isSuccess, setIsSuccess] = React.useState(false);

  const onLogin = ({ email }: { email: string }) => {
    setIsSuccess(false);

    requestPasswordReset(email).then((data) => {
      if (!("error" in data)) {
        setIsSuccess(true);

        trackEvent({
          action: "request_password_reset",
          category: "account",
          label: "request_password_reset",
        });
      } else {
        showNotification({
          id: "reset-status",
          title: "Aktion fehlgeschlagen",
          color: "red",
          message: (data.error as any).data.message,
        });

        trackEvent({
          action: "request_password_reset_failed",
          category: "account",
          label: "request_password_reset_failed",
        });
      }
    });
  };

  return (
    <AuthWindow
      action="Passwort vergessen"
      alternativeActionPreamble=""
      alternativeActionLink="/account/auth/login"
      alternativeActionText="Anmelden"
      isLoading={isLoading}
      noSocialLogin
    >
      <BaseAuthForm
        action="Passwort vergessen"
        onSubmit={form.onSubmit(onLogin)}
      >
        {isSuccess && (
          <Alert
            color="green"
            title="Link zum Zurücksetzen Ihres Passworts wurde versendet"
          >
            Bitte prüfen Sie Ihr Postfach und folgen Sie den Anweisungen, um Ihr
            Passwort zurückzusetzen.
          </Alert>
        )}
        <TextInput
          required
          label="Email"
          placeholder="musterperson@email.com"
          className="mb-6"
          error={getFormElementError("email", error)}
          {...form.getInputProps("email")}
        />
      </BaseAuthForm>
    </AuthWindow>
  );
}

export { getStaticProps } from "@lib/utils/translationsStaticProps";
export default ForgotPassword;
